/**
 * ActivityHighlights Section Component
 *
 * Displays activity highlights from audit logs.
 */

import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material'
import HistoryIcon from '@mui/icons-material/History'
import { ActivityHighlights as ActivityHighlightsType } from '../../../../../services/reportsApi'
import Metric from '../Metric'

interface ActivityHighlightsProps {
  data: ActivityHighlightsType
}

const ActivityHighlights: React.FC<ActivityHighlightsProps> = ({ data }) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <HistoryIcon color="primary" />
          <Typography variant="h6" component="h2">
            Activity Highlights
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={6} sm={2.4}>
            <Metric label="Logins" value={data.logins} />
          </Grid>
          <Grid item xs={6} sm={2.4}>
            <Metric label="Manual Syncs" value={data.manual_syncs} />
          </Grid>
          <Grid item xs={6} sm={2.4}>
            <Metric label="User Mgmt" value={data.user_management_actions} />
          </Grid>
          <Grid item xs={6} sm={2.4}>
            <Metric
              label="Failures"
              value={data.failed_operations}
              color={data.failed_operations > 0 ? '#d32f2f' : 'text.primary'}
            />
          </Grid>
          <Grid item xs={6} sm={2.4}>
            <Box
              component={RouterLink}
              to="/admin/feedback?date=today"
              sx={{ display: 'block', textDecoration: 'none', color: 'inherit' }}
            >
              <Metric label="Feedback" value={data.feedback_received} />
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 2, textAlign: 'right' }}>
          <Button
            component={RouterLink}
            to="/admin/system/audit-logs"
            size="small"
          >
            View Audit Logs
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default ActivityHighlights
